import { render, staticRenderFns } from "./WorkerCard.vue?vue&type=template&id=d4bed8fa"
import script from "./WorkerCard.vue?vue&type=script&lang=js"
export * from "./WorkerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports